var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadPointer = function SvgFadPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.402 54 124 212.904l39-39.812 30.186 30.39a3.756 3.756 0 0 0 5.5-.122l6.731-7.405c1.484-1.632 1.414-4.21-.165-5.767L175.648 161l37.957-37L56.402 54z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.995 84.615c-2.503-1.157-3.628-.05-2.514 2.471l41.64 94.202c.893 2.021 2.859 2.38 4.397.793l48.982-50.53c1.535-1.584 1.15-3.62-.847-4.545l-91.658-42.39z",
    fill: "#FFF"
  }))));
};
export { SvgFadPointer as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-pointer.cbe262c8.svg";